import React from 'react';
import Pagination from 'components/Pagination';

const FooterPagination = ({size, page, onChange}) => (
  <div className="paginations text-center footer-pagination">
    <Pagination
      className="d-inline-flex p-0 my-5 mx-auto"
      size={size}
      page={page}
      step={1}
      onChange={onChange}
    />
  </div>
);

export default FooterPagination;
